import React from 'react'
import { Ordering } from 'storfox-filter'

import { SUPPLIER_COLUMNS as tableColumns } from './SupplierTable'

import { FILTER_NAME as name } from '../../constants'

export const supplierOrderingOptions = {
  name,
  tableColumns
}

function SupplierOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default SupplierOrderingForm
